import SurepathLogomarkWhite from '../../assets/logomark-white-0924.svg';
import SurepathLogomarkCarbon from '../../assets/logomark-carbon-0924.svg';
import useAppTheme from '@/hooks/use-app-theme.hooks';
import { FC } from 'react';

interface Props {
  colorMode?: 'light' | 'dark';
}

const SurepathIcon: FC<Props> = ({ colorMode }: Props) => {
  const { colorMode: appColorMode } = useAppTheme();
  const compColorMode = colorMode || appColorMode;

  return (
    <img
      src={compColorMode === 'dark' ? SurepathLogomarkWhite : SurepathLogomarkCarbon}
      alt="SurePath AI"
      width="24px"
    />
  );
};

export default SurepathIcon;
